import { Box, Tab, Tabs, Typography } from '@mui/material';
import styled from 'styled-components';
import PropTypes from 'prop-types';

export const TabsContainer = styled(Tabs)`
  & span.MuiTabs-indicator {
    display: none;
  }
`;

export const CustomTab = styled(Tab)`
  &.MuiTab-root {
    color: #0997ba;
    border-bottom: 0;
    text-transform: none;
    font-size: 24px;

    &[aria-selected='true'] {
      color: #ee7b57;
      font-weight: bolder;
    }

    & span {
      display: none;
    }
  }
`;

export function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}>
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
};
